// extracted by mini-css-extract-plugin
export default {"FormContainer":"_DVzvklaLkkkkK3pGBsR"};